export const HERO = {
  TITLE_A: "Real-life",
  TITLE_B: "Role-Playing Game",
  PRIMARY_CTA: `Join waitlist`,
  SECONDARY_CTA: "Learn more",
}
